var map = {
	"./Applied - Filter.svg": 51386,
	"./AppsCount.svg": 19487,
	"./Default - filter.svg": 86110,
	"./Email_verify.svg": 35050,
	"./Expanded -  filter.svg": 70198,
	"./MessageBox.svg": 86562,
	"./NotificationBell.svg": 88940,
	"./Phone_verify.svg": 6950,
	"./Sessions.svg": 24317,
	"./add-icon.svg": 77735,
	"./applied-filterIcon.svg": 74551,
	"./blockedRequest.svg": 18665,
	"./botnet-High-Severity.svg": 97169,
	"./botnet-Low-Severity.svg": 54397,
	"./botnet-Medium-Severity.svg": 69830,
	"./botnet-critical.svg": 67436,
	"./botnet-high.svg": 14275,
	"./botnet-info.svg": 37915,
	"./botnet-low.svg": 42575,
	"./botnet-medium.svg": 58878,
	"./botnet-warning.svg": 5289,
	"./botnetIcon.svg": 47113,
	"./browser.svg": 25858,
	"./bug.svg": 9496,
	"./byod.svg": 84936,
	"./calender.svg": 42088,
	"./calender2.svg": 58314,
	"./calenderActive.svg": 84702,
	"./categories.svg": 90566,
	"./checkBox.svg": 99469,
	"./checkBoxActive.svg": 30747,
	"./close.svg": 63866,
	"./cross.svg": 7838,
	"./customersIcon.svg": 13310,
	"./dailyFilterApplied.svg": 51026,
	"./dangerDataRange.svg": 47018,
	"./dashboard.svg": 88942,
	"./dashboardDropdownList.svg": 30425,
	"./dataLocation.svg": 29419,
	"./default-filterIcon.svg": 63995,
	"./done.svg": 89734,
	"./down-arrow.svg": 97810,
	"./downArrow.svg": 38389,
	"./download.svg": 87822,
	"./dropdown.svg": 94657,
	"./email.svg": 24426,
	"./emptyWidget.svg": 32957,
	"./enterprise-selected.svg": 3191,
	"./enterprise.svg": 10187,
	"./expent.svg": 49382,
	"./filter.svg": 71420,
	"./filter2.svg": 4102,
	"./filterApplied.svg": 6267,
	"./fully-managed.svg": 20030,
	"./goodDataRange.svg": 32488,
	"./ijura_blue_logo.svg": 33200,
	"./ijura_logo_svg.svg": 11124,
	"./ijura_logo_updated.svg": 2091,
	"./import.svg": 97261,
	"./intrusions-critical-bottom.svg": 41766,
	"./intrusions-critical-top.svg": 6332,
	"./intrusions-high-bottom.svg": 95487,
	"./intrusions-high-top.svg": 77283,
	"./intrusions-info-bottom.svg": 5015,
	"./intrusions-info-top.svg": 44779,
	"./intrusions-low-bottom.svg": 80891,
	"./intrusions-low-top.svg": 59887,
	"./intrusions-medium-bottom.svg": 34932,
	"./intrusions-medium-top.svg": 70798,
	"./intrusions-warning-bottom.svg": 57569,
	"./intrusions-warning-top.svg": 13881,
	"./intrusions.svg": 19140,
	"./intrusionsCriticalSeverity.svg": 55742,
	"./intrusionsCriticalSeverityLight.svg": 38946,
	"./intrusionsHighSeverity.svg": 71677,
	"./intrusionsHighSeverityLight.svg": 61667,
	"./intrusionsInfoSeverity.svg": 59117,
	"./intrusionsInfoSeverityLight.svg": 83955,
	"./intrusionsLowSeverity.svg": 81707,
	"./intrusionsLowSeverityLight.svg": 78617,
	"./intrusionsMediumSeverity.svg": 18956,
	"./intrusionsMediumSeverityLight.svg": 54064,
	"./iot.svg": 17926,
	"./locked.svg": 8532,
	"./logout.svg": 63180,
	"./malacious-phishing.svg": 60581,
	"./menuDashboard.svg": 76697,
	"./menuManageDevice.svg": 5160,
	"./menuManageUser.svg": 73603,
	"./mobileTypeA-icon.svg": 57401,
	"./mobileTypeB-icon.svg": 57120,
	"./mobileTypeC-icon.svg": 56955,
	"./monthlyFilterApplied.svg": 72222,
	"./more-icon.svg": 98893,
	"./more_horiz.svg": 67522,
	"./personal-selected.svg": 52172,
	"./personal.svg": 34638,
	"./phone.svg": 8382,
	"./plus.svg": 14066,
	"./question-grey.svg": 76050,
	"./question.svg": 83926,
	"./radioActive.svg": 45057,
	"./radioSvg.svg": 85519,
	"./rightArrow.svg": 58195,
	"./search.svg": 98246,
	"./send.svg": 62608,
	"./settings.svg": 70421,
	"./signs.svg": 63860,
	"./signup-image.svg": 30086,
	"./sim.svg": 75203,
	"./subscribers.svg": 76143,
	"./suscriber.svg": 64938,
	"./toggle.svg": 18070,
	"./totalDataConsumption.svg": 46425,
	"./usedApplication.svg": 29921,
	"./user.svg": 46975,
	"./userDataConsumption.svg": 53236,
	"./userLigth.svg": 24613,
	"./verified-white.svg": 80354,
	"./verified.svg": 89126,
	"./view-more.svg": 5433,
	"./virus-High-Severity.svg": 80618,
	"./virus-Low-Severity.svg": 99252,
	"./virus-Medium-Severity.svg": 85573,
	"./virusIcon.svg": 66890,
	"./virusVictim.svg": 63181,
	"./warning.svg": 28330,
	"./warningDataRange.svg": 37977,
	"./weeklyFilterApplied.svg": 8616,
	"./whiteDataRange.svg": 52332,
	"./whiteUser.svg": 97564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92282;